import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const BoundingBoxLabelTriangleIcon: FunctionComponent<Props> = ({
    className = '',
    testId = TEST_ID
}) => (
    <svg
        className={className}
        data-testid={testId}
        fill='none'
        height='10'
        viewBox='0 0 11 10'
        width='11'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M5.76465 8.75C5.57217 9.0831 5.0919 9.0831 4.89941 8.75L0.569337 1.25C0.376887 0.916666 0.617054 0.499999 1.00195 0.499999L9.66211 0.5C10.047 0.5 10.2872 0.916666 10.0947 1.25L5.76465 8.75Z'
            stroke='currentColor'
        />
    </svg>
);

export default BoundingBoxLabelTriangleIcon;
